import React from 'react';

const Accessibility = (props) => (
	<svg
		id="ikony"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<g>
				<circle cx={11} cy={5} r={2}/>
				<polygon
					points="5 10 8 11 8 17.99 10 17.99 11 14 12 17.99 14 17.99 14 11 17 10 17 8 5 8 5 10"
				/>
				<path
					d="m11,.5C5.2.5.5,5.2.5,11s4.7,10.5,10.5,10.5,10.5-4.71,10.5-10.5S16.8.5,11,.5Zm0,20c-5.25,0-9.5-4.26-9.5-9.5S5.75,1.5,11,1.5s9.5,4.25,9.5,9.5-4.25,9.5-9.5,9.5Z"
				/>
			</g>
		</g>
	</svg>
);

export default Accessibility;
